// Global Types
import type {
  $Children,
} from 'common.types';

// Global Components
import * as React from 'react';
import {
  Loader,
} from '@vroskus/library-components';

// Helpers
import {
  animationClass,
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Components
import RegionDialog from '../../dialog/RegionDialog';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = {
  children: $Children;
  id: string;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  initalised: boolean;
};

class PageView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      initalised: true,
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    this.trackRegattaChange(prevProps);
  }

  trackRegattaChange(prevProps: $Props): void {
    const {
      main: {
        activeRegattaId,
      },
    } = this.props;

    if (isDiff(
      activeRegattaId,
      prevProps.main.activeRegattaId,
    )) {
      this.setState(
        {
          initalised: false,
        },
        () => this.setState({
          initalised: true,
        }),
      );
    }
  }

  render() {
    const {
      children,
      id,
      main,
    } = this.props;
    const {
      initalised,
    } = this.state;

    return (
      <div
        className={`Page ${animationClass('fadeIn')} p-3`}
        id={id}
      >
        {main.showRegionSelector === true && (
          <RegionDialog />
        )}
        <Loader
          loading={initalised === false}
          overlay
        >
          {children}
        </Loader>
      </div>
    );
  }
}

export default PageView;
